import React from 'react';
import classess from  './CustomDropdown.scss';

class CustomDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.appRoute = app.appUtil.getAppRoutes().TURNONMFA || {};
    this.addNewIcon = app.appUtil.getDrupalURL() + this.appRoute['ADD_NEW_ICON'];
    this.tickIcon = drupalSettings.path.baseUrl  + 'sites/default/files/react_images/Tick_Icon.svg';
  }

    handleSelect = (value,encrypted) => {
      this.props.onChange(value,encrypted);
      this.setState({ isOpen: false });
    }

    toggleDropdown = () => {
      this.setState((prevState) => ({
        isOpen: !prevState.isOpen
      }));
    }

    render() {
      const { options, selectedValue, onEnterKeyPress  } = this.props;
      const { isOpen } = this.state;
      const icon = isOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down';

      return (
        <div className={classess.customDropdown}>
          <div className={classess.selected} onClick={this.toggleDropdown} onKeyDown={(event) => onEnterKeyPress(event,this.toggleDropdown)} tabIndex={0}>
            <div>
              {selectedValue === 'add-new' ? 'Add a new number' : selectedValue}
            </div>
            <i key={icon} style={{color: '#00664F'}}><span className={icon} /></i>
          </div>
          {isOpen && (
            <div className={classess.options}>
              {options.map((option) => (
                <div
                  key={option.value}
                  className={`${classess.option} ${option.value === selectedValue ? classess.optionActive : ''}`}
                  onClick={() => this.handleSelect(option.value,option.encrypted)}
                  onKeyDown={(event) => onEnterKeyPress(event,() => this.handleSelect(option.value,option.encrypted))}
                  tabIndex={0}
                >
                  {option.value === 'add-new' && (<img alt={'Add new'} className={classess.addNew} src={this.addNewIcon} />)} 
                  {option.label}
                  {option.value === selectedValue && <img alt={'Tick Icon'} className={classess.tickMark} src={this.tickIcon} />}
                </div>
              ))}
            </div>
          )}
        </div>
      );
    }
}

export default CustomDropdown;
